module.exports = __webpack_public_path__ + "assets/img/shop_detail_img2.828e3a9a.png";